import { testIds } from './AuditFormMainInfoViewTestIds';
import AuditFormMainInfoView from './AuditFormMainInfoView';
import { useStyles } from './AuditFormMainInfoStyle';

export { useStyles, testIds };

export default AuditFormMainInfoView;
